// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as EditProfileActions } from '../../edit-profile/duck';
import { actions as AlertActions } from '../../../alert/duck';
import Referral from '../components/Referral';

import type { RootState } from '../../../index';

function mapStateToProps(state: RootState) {
  return {
    user: state.auth.user,
  }
}

/*function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ }, dispatch);
}*/

export default connect(mapStateToProps, null)(Referral);



// WEBPACK FOOTER //
// ./src/modules/preferences/referral/containers/ReferralContainer.js